import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { Home, FileText, Bot, Shield } from 'lucide-react';
import { cn } from '@/lib/utils';
import { PushNotificationToggle } from '@/components/notifications/PushNotificationToggle';

const navItems = [
  { path: '/portal', icon: Home, label: 'Início' },
  { path: '/portal/documents', icon: FileText, label: 'Documentos' },
  { path: '/portal/luna', icon: Bot, label: 'Luna' },
  { path: '/portal/privacy', icon: Shield, label: 'Privacidade' },
];

export function PortalLayout() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background pb-16">
      {/* Portal Header */}
      <header className="border-b bg-primary px-4 py-3 sticky top-0 z-50">
        <div className="mx-auto max-w-lg flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src="/logo-ativacare.svg" alt="ativaCare" className="h-6 brightness-0 invert" />
            <span className="text-lg font-semibold text-primary-foreground">
              Meu ativaCare
            </span>
            <span className="rounded bg-amber-500 px-1.5 py-0.5 text-[9px] font-bold text-white">
              DEMO
            </span>
          </div>
          <PushNotificationToggle
            isPortal
            iconOnly
            className="text-primary-foreground hover:bg-primary-foreground/10"
          />
        </div>
      </header>

      {/* Content */}
      <main className="mx-auto max-w-lg px-4 py-6">
        <Outlet />
      </main>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 border-t bg-background z-50">
        <div className="mx-auto max-w-lg">
          <div className="flex items-center justify-around py-2">
            {navItems.map((item) => {
              const isActive =
                item.path === '/portal'
                  ? location.pathname === '/portal'
                  : location.pathname.startsWith(item.path);

              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={cn(
                    'flex flex-col items-center gap-1 px-3 py-2 rounded-lg transition-colors',
                    isActive
                      ? 'text-primary'
                      : 'text-muted-foreground hover:text-foreground'
                  )}
                >
                  <item.icon className="h-5 w-5" />
                  <span className="text-xs font-medium">{item.label}</span>
                </NavLink>
              );
            })}
          </div>
        </div>
      </nav>
    </div>
  );
}
